import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase yapılandırması - Bu değerleri Firebase Console'dan alınız
// Firebase Console > Project Settings > General > Your apps > Config
const firebaseConfig = {
  apiKey: "AIzaSyBDClO83JkClLBIWlEpjUVCtskb_8LUex0",
  authDomain: "taxicim-app.firebaseapp.com",
  projectId: "taxicim-app",
  storageBucket: "taxicim-app.firebasestorage.app",
  messagingSenderId: "123456789012", // Firebase Console'dan alın
  appId: "1:123456789012:web:abcdefghijklmnop", // Firebase Console'dan alın
  measurementId: "G-XXXXXXXXXX" // Firebase Console'dan alın (Analytics varsa)
};

// Firebase'i başlat
let app;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// Firebase servislerini dışa aktar
export const auth = getAuth(app);

// Belirli database'i kullan: taxicim8965
export const db = getFirestore(app, 'taxicim8965');
export const storage = getStorage(app);

export default app; 